module.exports = __webpack_public_path__ + "img/top2.6f8d86e5.png";